import { mapGetters } from 'vuex';
import { Maths } from '@garmin/support-utils';
import ScDataListIterator from '@garmin/support-components/src/components/ScDataListIterator/index.vue';
import TranslatableContentMixin from '../../mixins/translations';

export default {
  name: 'TheExchangeSidebar',
  components: {
    ScDataListIterator,
  },
  mixins: [TranslatableContentMixin],
  computed: {
    ...mapGetters('customer', ['deviceVerificationResponse', 'suppliedFormData']),

    getRMASubtotal() {
      let subtotalPrice = this.deviceVerificationResponse?.paidRMADetails?.subtotal;
      if (this.deviceVerificationResponse?.autoRMAScenario) subtotalPrice = 0;

      return subtotalPrice;
    },
    getRMATotal() {
      let rmaPrice = this.deviceVerificationResponse?.paidRMADetails?.repairPrice;
      if (this.deviceVerificationResponse?.autoRMAScenario) rmaPrice = 0;

      return rmaPrice;
    },
    getEstimatedTax() {
      if (this.deviceVerificationResponse?.autoRMAScenario) {
        return 0;
      }
      return (this.deviceVerificationResponse?.paidRMADetails?.estimatedTaxAmount
        ? this.deviceVerificationResponse?.paidRMADetails.estimatedTaxAmount : 0);
    },
    getOrderCostSummaryItems() {
      const rmaSubtotal = this.getRMASubtotal;
      const totalRMAPrice = this.getRMATotal;
      const estimatedTax = this.getEstimatedTax;
      const customerLocale = this.suppliedFormData?.selectedCountryRegion?.locale;
      const currency = this.deviceVerificationResponse?.paidRMADetails?.currency;
      return [...(
        (totalRMAPrice || Number(totalRMAPrice) === 0)
          && customerLocale
          && currency
      ) ? [
          {
            label: this.translations.subtotalLabel,
            value: `${Maths.getFormattedPrice(rmaSubtotal, customerLocale, currency)} ${currency}`,
          },
          {
            label: this.translations.shippingLabel,
            value: `${Maths.getFormattedPrice(0, customerLocale, currency)} ${currency}`,
          },
          {
            label: this.translations.estTaxLabel,
            // eslint-disable-next-line max-len
            value: (estimatedTax !== 0) ? `${Maths.getFormattedPrice(estimatedTax, customerLocale, currency)} ${currency}` : this.translations.estTaxValue,
          },
          {
            label: this.translations.estTotalLabel,
            value: `${Maths.getFormattedPrice(totalRMAPrice, customerLocale, currency)} ${currency}`,
          },
        ]
        : []];
    },
  },
};
